// ============================================================
// 🔒 PortalGuard — protège les pages du portail client (Phase 18)
// Si pas de session portail valide => redirection vers /login.
// (Distinct de AdminGuard qui protège les routes admin.)
// ============================================================
import React from "react";
import { Navigate } from "react-router-dom";
import { usePortalAuth } from "../context/PortalAuthContext";

export default function PortalGuard({ children }) {
  const { authenticated, loading } = usePortalAuth();

  if (loading) return null;                       // check /me en cours
  if (!authenticated) return <Navigate to="/portal/login" replace />;
  return children;
}
